
const state = {
  pageActive:1, //高亮

  isShowActive:2,
}

const mutations = {
  SET_PAGE_ACTIVE: (state, params) => {
    state.pageActive = params
  },
  SET_SHOW_ACTIVE: (state, params) => {
    state.isShowActive = params
  },
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
